import React from 'react';

import { LoadingWheel } from '../base/LoadingWheel';
import { Select } from '../base/Select';

import useSuperAdminApplianceManufacturers from '../../data/appliance/useSuperAdminApplianceManufacturers';

export interface ManufacturerSelectProps {
  type?: string;
}

export const ManufacturerSelect = React.forwardRef<
  any,
  ManufacturerSelectProps
>(({ type, ...rest }, ref) => {
  const { superAdminApplianceManufacturers } =
    useSuperAdminApplianceManufacturers(type);

  if (superAdminApplianceManufacturers.isLoading) {
    return (
      <div className="flex items-center justify-center">
        <LoadingWheel size="sm" />
      </div>
    );
  } else {
    return (
      <Select ref={ref} label="Manufacturer" {...rest}>
        <option disabled selected hidden></option>
        {superAdminApplianceManufacturers.data?.map((type) => (
          <option key={type.id} value={type.id}>
            {type.name}
          </option>
        ))}
      </Select>
    );
  }
});
